import image from "../../Assets/form.jpeg";

const Support = () => {
  const inputs = [{ name: "Name" }, { name: "Email" }, { name: "Phone" }];
  return (
    <section className="px-6 my-16 text-blackColor xl:px-0 md:my-32">
      <div  className="mx-auto max-w-6xl h-full flex flex-col-reverse md:gap-4 lg:flex-row-reverse lg:gap-10">
        <div className="lg:w-1/2">
          <h2 className="hidden font-semibold text-4xl leading-[3.4rem] lg:block">
            Get started with Lipana, <br />
            talk to our team.
          </h2>

          <h2 className="block font-semibold text-2xl md:text-4xl md:leading-[3.4rem] lg:hidden">
            Get started with Lipana, talk to our team.
          </h2>

          <div className="flex flex-row gap-2">
            <p>Call or whatsapp at</p>
            <a href="tel:+254791814113" className="underline">+254791814113</a>
          </div>

          <p className="my-3">
            Send us an email at
            <a href="mailto:support@lipana.co.ke" className="ml-1.5 underline cursor-pointer">support@lipana.co.ke</a>
          </p>
          <h3 className="font-semibold">Request a callback from our team.</h3>
          <form className="bg-white p-5 rounded-[20px] w-full space-y-5 mt-10 shadow-[0px 4px 4px rgba(0, 0, 0, 0.1)] md:p-10 md:rounded-[40px] lg:w-3/4">
            {inputs.map((input, i) => (
              <input
                key={i}
                type="text"
                placeholder={input.name}
                className="bg-gray-100 border outline-none rounded-xl p-4 block w-full"
              />
            ))}
            <textarea
              name=""
              id=""
              cols="30"
              rows="3"
              placeholder="Your message ..."
              className="border bg-gray-100 w-full rounded-xl p-4 outline-none resize-none"
            />
            <input
              type="submit"
              value="Send Message"
              className="bg-brandColor cursor-pointer text-white w-full py-3 rounded-full text-lg font-semibold"
            />
          </form>
        </div>
        <div className="mb-8 md:mb-0 lg:w-1/2">
          <img
            src={image}
            alt="form"
            className="w-full object-cover rounded-[20px] h-72 md:h-96 lg:h-[745px] md:rounded-[40px]"
          />
        </div>
      </div>
    </section>
  );
};

export default Support;
